module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag17_0846AT.ed8ede76.jpg";